import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const NowrapWrapper = ({ title, size = 14 }) => {
  return <Box sx={{ textWrap: 'nowrap', fontSize: `${size}px` }}>{title}</Box>;
};

NowrapWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  size: PropTypes.number,
};

export default NowrapWrapper;
